export function normalizeWorkspaceTipo(tipo) {
  const t = String(tipo || '').trim().toUpperCase()
  if (t === 'TASK' || t === 'TAREFA') return 'TAREFAS'
  return t
}

export function isServicosWorkspace(ws) {
  if (!ws) return false
  return normalizeWorkspaceTipo(ws.tipo) === 'SERVICOS'
}

export function isCrmWorkspace(ws) {
  if (!ws) return false
  return normalizeWorkspaceTipo(ws.tipo) === 'CRM'
}

export function isTarefasWorkspace(ws) {
  if (!ws) return false
  const t = normalizeWorkspaceTipo(ws.tipo)
  return t === 'TAREFAS' || t === ''
}

export function defaultWorkspaceRoute(ws) {
  if (!ws?.id) return '/dashboard'
  if (isServicosWorkspace(ws)) return `/workspace/${ws.id}/clientes`
  return `/workspace/${ws.id}/dashboard`
}
